import { Button, Col, Row, Form } from "react-bootstrap";
import GamMappingList from "./gamMappingList";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../../services/axiosInstance";

const InclusionExclusionList = () => {
    const [mappingList, setMappingList] = useState([]);
    const [incExcPayload, setIncExcPayload] = useState('');

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const pubId = queryParams.get("accountId");
    const gamId = queryParams.get("gamAccountId");

    const [status, setStatus] = useState(queryParams.get("inclusionStatus"));

    const navigate = useNavigate();

    const gamMappingList = async () => {
        const res = await API.get(`/publisher/gam/setting/getGamMappingList/${gamId}/${status}/${pubId}`);
        if (res.status === 200) {
            const data = res?.data?.data;
            setMappingList(data);
        }

    }

    useEffect(() => {
        gamMappingList();
    }, [])

    // on click generate list All,Inclusion & Exclusion
    const handleGenerateList = () => {
        if (status === "2") {
            navigate(`/gamsetting/${gamId}/${pubId}/${status}/gam/mapping`);
        } else {
            gamMappingList();
            navigate(`/gamsetting/list/inclusion_exclusion?inclusionStatus=${status}&gamAccountId=${gamId}&accountId=${pubId}`);
        }
    }

    // make exclusion to inclusion and vice-versa
    const handleIncExcButton = async () => {
        try{
        const response = await API.put(`/publisher/gam/setting/update/incexc/status`,incExcPayload);
        if (response?.data?.status === "Success") {
            alert(response?.data?.message);
            window.location.reload();
        } else {
            alert(response?.data?.message || "Failed");
        }
    }catch(err){
        console.log(err);
        alert('Failed');
    }
    }

    function payload(data) {
        // console.log(data);  
        // set payload to it
        setIncExcPayload(data);

    }

    return (
        <>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Link to={'/gamsetting'}><span>Gamsetting</span></Link>
                <span>List</span>
                <span>Inclusion / exclusion</span>
            </div>
            <div style={{ background: "#f5f5f5", padding: "25px" }}>
                <Row>
                    <Col md={2}>
                        <h5>View Mapping</h5>

                        <Form.Group className="mt-4">
                            <Form.Label>Status</Form.Label>
                            <Form.Select value={status}
                                onChange={(e) => setStatus(e.target.value)}>
                                <option value="2">All</option>
                                <option value="0">Inclusion</option>
                                <option value="1">Exclusion</option>
                            </Form.Select>
                        </Form.Group>

                        <Button className="mt-4" onClick={handleGenerateList} >Generate List</Button>
                    </Col>
                    <Col md={4} className="ms-auto">
                        <Button className="btn btn-success btn-fw mr-4 float-right" onClick={handleIncExcButton}>{status == '1' ? 'Inclusion' : 'Exclusion'}</Button>
                    </Col>
                </Row>
            </div>
            <GamMappingList payload={payload} mappingList={mappingList} />
        </>
    );
}
export default InclusionExclusionList;